import React from 'react'
import styled from 'styled-components'
import { Button, useWalletModal } from '@pancakeswap-libs/uikit'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import useI18n from 'hooks/useI18n'

const H = styled.p`
  font-size: 1.5rem;
  color: green;

  @media only screen and (max-width: 600px) {
    font-size: 1.5rem;
  }
`

const UnlockButton = (props) => {
  const TranslateString = useI18n()
  const { connect, reset } = useWallet()
  const { onPresentConnectModal } = useWalletModal(connect, reset)

  return (
    <Button variant="danger" onClick={onPresentConnectModal} {...props}>
      <H>{TranslateString(292, 'Unlock Wallet')}</H>
    </Button>
  )
}

export default UnlockButton
